/**
 * Подсчитывает разницу между двумя строками
 *
 * @param {string} a - оригинальная строка
 * @param {string} b - строка для проверки
 * @returns {number} количество символов - разница между a и b
 */
export const diffBetweenWords = (a, b) => {
    let v0 = [];
    let v1 = [];

    if (a == b) {return 0;}

    if (!a.length || !b.length) {
        return Math.max(a.length, b.length);
    }

    for (let i = 0; i < b.length + 1; i++) {v0[i] = i;}

    for (let i = 0; i < a.length; i++) {
        v1[0] = i + 1;

        for (let j = 0; j < b.length; j++) {
            var cost = Number(a[i] != b[j]);
            v1[j + 1] = Math.min(v1[j] + 1, v0[j + 1] + 1, v0[j] + cost);
        }

        for (let j = 0; j < v0.length; j++) {
            v0[j] = v1[j];
        }
    }

    return v1[b.length];
};
